import ShellCard from "../../components/ShellCard.jsx";
import floridaHandbookEn from "../../assets/images/florida-driver-license-handbook.png";
import floridaHandbookEs from "../../assets/images/florida-driver-license-handbook-es.png";
import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";

const FloridaDriverHandbook = () => {
    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Florida Driver Handbook</h1>
                            <p className="banner-subheading">Metro Traffic School</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <ShellCard>
                            <div className="mb-5">
                                <h3 className="fw-bold mb-3" style={{ color: "var(--metro-yellow)" }}>
                                    The Florida Driver Handbook For The Florida Driving Test
                                </h3>
                                <p className="mb-3" style={{ color: "#fff" }}>
                                    Looking for the Florida Driver Handbook? Getting ready to take the
                                    Florida driving test? You’ve come to the right place! For your
                                    convenience, you will find the free online version of the most
                                    recent Official Florida Driver’s Handbook below. The Florida
                                    Driver's Handbook is available in English and Spanish.
                                </p>
                                <p className="mb-3" style={{ color: "#fff" }}>
                                    This Official Florida Driver Handbook is provided by the Florida
                                    DMV, and is up-to-date. The Florida driver’s handbook is your
                                    source for all the rules and regulations for Florida drivers. If
                                    you are getting your first driver’s license in Florida, the
                                    driver handbook is your study guide to prepare you for the
                                    Florida driving test.
                                </p>
                                <p className="mb-3" style={{ color: "#fff" }}>
                                    The Florida driver’s manual below provides basic information to
                                    be a safe driver and understand Florida’s traffic laws and
                                    regulations.This information, along with practicing responsible
                                    safe driving can help protect you, your passengers and other
                                    highway users. It will teach you the basic information you will
                                    need to know to pass the Florida driving test. By studying the
                                    Florida driver’s handbook, you will learn rules of the road, and
                                    you will also learn how to be safe on the road.
                                </p>
                                <p className="mb-5" style={{ color: "#fff" }}>
                                    We hope you will enjoy studying this Florida Driver Handbook.
                                    Feel free to share this link with your friends who are getting
                                    ready to take the Florida driving test too!
                                </p>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
                                    <a
                                        href="https://www.flhsmv.gov/pdf/handbooks/englishdriverhandbook.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            src={floridaHandbookEn}
                                            alt="Florida Driver License Handbook English"
                                            className="img-fluid shadow-sm"
                                            style={{ maxHeight: "400px" }}
                                        />
                                    </a>
                                </div>
                                <div className="col-12 col-md-4 text-center">
                                    <a
                                        href="https://www.flhsmv.gov/pdf/handbooks/spanishdriverhandbook.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            src={floridaHandbookEs}
                                            alt="Florida Driver License Handbook Spanish"
                                            className="img-fluid shadow-sm"
                                            style={{ maxHeight: "400px" }}
                                        />
                                    </a>
                                </div>
                            </div>

                            <div className="mt-5 text-white">
                                <p>
                                    Superb Customer Service
                                </p>
                                <p>
                                    At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                                </p>
                            </div>
                        </ShellCard>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FloridaDriverHandbook;
